import { LEGAL, type LegalSet } from './meta';

const { company: C, email: E } = LEGAL;

export const pl: LegalSet = {
  privacy: {
    title: 'Polityka prywatności',
    intro: `Niniejsza polityka wyjaśnia, jakie dane osobowe ${C} („my”) zbiera, gdy korzystasz ze strony internetowej, edytora i API („Serwis”), w jakim celu je zbieramy oraz jakie przysługują Ci prawa.`,
    sections: [
      {
        h: '1. Jakie dane zbieramy',
        p: [
          'Dane konta: imię, adres e-mail, skrót (hash) hasła, język interfejsu oraz — jeśli logujesz się przez Google — identyfikator konta Google i zweryfikowany adres e-mail.',
          'Treści: szablony, obrazy, czcionki, tabele i inne przesyłane przez Ciebie pliki, dane wysyłane do API w celu wygenerowania obrazów oraz wygenerowane obrazy.',
          'Dane o korzystaniu z Serwisu: generowania obrazów, uruchomienia automatyzacji, zapytania do AI, klucze API (przechowywane w postaci skrótów), sesje logowania, adres IP i identyfikator przeglądarki (user agent), logi błędów.',
          'Dane rozliczeniowe: plan, status subskrypcji i identyfikatory płatności. Danymi kart płatniczych zajmuje się operator płatności (Lemon Squeezy lub Stripe) i nigdy nie trafiają one na nasze serwery.',
        ],
      },
      {
        h: '2. Jak wykorzystujemy dane',
        p: [
          'Aby świadczyć Serwis: przechowywać Twoje szablony, generować obrazy, uruchamiać automatyzacje i dostarczać wyniki do podłączonych przez Ciebie integracji.',
          'Aby zapewnić bezpieczeństwo i niezawodność Serwisu: uwierzytelnianie, zapobieganie nadużyciom, limity zapytań, diagnozowanie błędów i kopie zapasowe.',
          'Aby wystawiać rozliczenia i egzekwować limity planów oraz wysyłać wiadomości serwisowe (reset hasła, zaproszenia, ważne zmiany). Nie wysyłamy wiadomości marketingowych bez Twojej zgody.',
        ],
      },
      {
        h: '3. Podstawy prawne',
        p: [
          'Przetwarzamy dane w celu wykonania zawartej z Tobą umowy, wypełnienia obowiązków prawnych oraz na podstawie naszego prawnie uzasadnionego interesu w prowadzeniu bezpiecznego serwisu. Tam, gdzie jest to wymagane, prosimy o Twoją zgodę.',
        ],
      },
      {
        h: '4. Funkcje AI',
        p: [
          'Gdy korzystasz z generowania AI, wprowadzony przez Ciebie opis lub tekst jest przesyłany do naszego dostawcy AI (Google Gemini API) w celu uzyskania wyniku. Nie przesyłamy Twoich pozostałych szablonów ani plików. Dostawca przetwarza te dane na własnych warunkach i nie wykorzystuje płatnego ruchu API do trenowania swoich modeli.',
        ],
      },
      {
        h: '5. Udostępnianie danych',
        p: [
          'Nie sprzedajemy danych osobowych. Udostępniamy je wyłącznie podmiotom przetwarzającym, które pomagają nam prowadzić Serwis — hosting i przechowywanie danych, płatności (Lemon Squeezy, Stripe), wysyłka e-maili, generowanie AI (Google) — oraz integracjom, które podłączasz samodzielnie (Google Drive, Sheets, S3, webhooki).',
          'Możemy ujawnić dane, gdy wymaga tego prawo lub w celu ochrony naszych użytkowników i Serwisu.',
          'Niektóre podmioty przetwarzające (np. Google) mogą przetwarzać dane poza EOG. Takie przekazania opierają się na EU–US Data Privacy Framework lub standardowych klauzulach umownych Komisji Europejskiej.',
        ],
      },
      {
        h: '6. Okres przechowywania',
        p: [
          'Przechowujemy dane konta i treści, dopóki Twoje konto jest aktywne. Wygenerowane obrazy i logi są przechowywane zgodnie z Twoim planem i ustawieniami. Po usunięciu przestrzeni roboczej lub konta dane są usuwane w ciągu 30 dni, z wyjątkiem sytuacji, w których przepisy prawa zobowiązują nas do dłuższego przechowywania (na przykład faktur).',
        ],
      },
      {
        h: '7. Pliki cookie',
        p: [
          'Niezbędne pliki cookie (bez zgody): cookie sesji, które utrzymuje Cię w stanie zalogowania, oraz krótkotrwałe cookie do logowania przez Google. Język, wybraną przestrzeń roboczą i Twój wybór dotyczący cookie zapisujemy w przeglądarce.',
          'Analityczne pliki cookie — tylko za Twoją zgodą: Google Analytics 4 (Google Ireland Ltd.) mierzy odwiedziny za pomocą pseudonimowych identyfikatorów w plikach _ga (do 2 lat); Google przechowuje dane 14 miesięcy, Google Signals i funkcje reklamowe są wyłączone. Analityka nie jest ładowana, dopóki jej nie zaakceptujesz w banerze cookie, a zgodę możesz wycofać w każdej chwili w „Ustawieniach cookie” w stopce lub w profilu. Nie używamy reklamowych plików cookie.',
        ],
      },
      {
        h: '8. Bezpieczeństwo',
        p: [
          'Hasła i klucze API są przechowywane w postaci skrótów, dane uwierzytelniające integracji są szyfrowane, a ruch jest chroniony protokołem HTTPS. Żaden system nie jest w pełni bezpieczny, ale stosujemy rozsądne środki w celu ochrony Twoich danych.',
        ],
      },
      {
        h: '9. Twoje prawa',
        p: [
          `Masz prawo dostępu, sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia danych i sprzeciwu (art. 15–21 RODO). W Ustawienia → Profil możesz pobrać kopię swoich danych i samodzielnie usunąć konto. Możesz również wnieść sprzeciw wobec przetwarzania, wycofać zgodę oraz złożyć skargę do organu ochrony danych osobowych. Aby skorzystać ze swoich praw, napisz na adres ${E}.`,
        ],
      },
      {
        h: '10. Dzieci',
        p: [
          'Serwis nie jest przeznaczony dla osób poniżej 16. roku życia i świadomie nie zbieramy ich danych.',
        ],
      },
      {
        h: '11. Zmiany i kontakt',
        p: [
          `Zmiany będziemy publikować na tej stronie, a o istotnych zmianach powiadomimy Cię e-mailem. Pytania dotyczące prywatności: ${E}.`,
        ],
      },
    ],
  },
  terms: {
    title: 'Regulamin',
    intro: `Niniejszy regulamin określa zasady korzystania z ${C} („Serwis”). Tworząc konto lub korzystając z Serwisu, akceptujesz te zasady. Jeśli korzystasz z Serwisu w imieniu firmy, akceptujesz je w jej imieniu.`,
    sections: [
      {
        h: '1. Serwis',
        p: [
          'Serwis umożliwia projektowanie szablonów graficznych, generowanie obrazów za pomocą edytora, API i automatyzacji oraz korzystanie z funkcji AI. Z czasem możemy zmieniać i ulepszać funkcje.',
        ],
      },
      {
        h: '2. Konto',
        p: [
          'Musisz podawać prawdziwe informacje oraz zachować w poufności swoje hasło i klucze API. Odpowiadasz za wszystkie działania wykonywane za pośrednictwem Twojego konta i przestrzeni roboczych. Jeśli podejrzewasz nieuprawniony dostęp, niezwłocznie nas o tym poinformuj.',
        ],
      },
      {
        h: '3. Plany, płatności i rezygnacja',
        p: [
          'Płatne plany są rozliczane z góry, miesięcznie lub rocznie, i odnawiają się automatycznie. Płatności obsługuje nasz pośrednik Lemon Squeezy (sprzedawca formalny, który rozlicza również podatki od sprzedaży) lub Stripe. Kilka dni przed każdym odnowieniem wysyłamy e-mail z przypomnieniem, a po nim — potwierdzenie płatności. Limity korzystania dla każdego planu są podane na stronie z cennikiem; po osiągnięciu limitu powiązane działania są wstrzymywane do następnego okresu rozliczeniowego lub zmiany planu na wyższy.',
          'Jeśli płatność za odnowienie się nie powiedzie, plan działa jeszcze przez kilka dni, abyś mógł zaktualizować metodę płatności; jeśli płatność nadal nie zostanie zrealizowana, przestrzeń robocza zostanie przeniesiona na plan Free. Twoje szablony i pliki zostaną zachowane.',
          'Możesz zrezygnować w dowolnym momencie: plan pozostaje aktywny do końca opłaconego okresu i nie jest odnawiany. Płatności nie podlegają zwrotowi, z wyjątkiem przypadków przewidzianych przez prawo. Możemy zmienić ceny z co najmniej 30-dniowym wyprzedzeniem.',
        ],
      },
      {
        h: '4. Twoje treści',
        p: [
          'Zachowujesz wszelkie prawa do przesyłanych szablonów, plików i danych oraz do generowanych obrazów. Udzielasz nam ograniczonej licencji na przechowywanie, przetwarzanie i wyświetlanie tych treści wyłącznie w celu świadczenia Ci Serwisu.',
          'Odpowiadasz za posiadanie praw do wykorzystywanych treści, w tym obrazów, czcionek, logotypów i znaków towarowych.',
        ],
      },
      {
        h: '5. Dozwolone korzystanie',
        p: [
          'Nie wolno Ci wykorzystywać Serwisu do tworzenia ani rozpowszechniania treści niezgodnych z prawem, treści naruszających prawa innych osób, złośliwego oprogramowania, spamu lub materiałów wprowadzających w błąd, treści wykorzystujących małoletnich ani do nękania innych osób.',
          'Nie wolno Ci podejmować prób zakłócenia działania lub przeciążenia Serwisu, obchodzenia limitów lub zabezpieczeń ani odsprzedawania dostępu bez naszej zgody. Możemy zawiesić konta naruszające te zasady.',
        ],
      },
      {
        h: '6. Funkcje AI',
        p: [
          'Wyniki AI są generowane automatycznie i mogą być niedokładne lub podobne do wyników uzyskanych przez innych użytkowników. Sprawdź je przed publikacją; odpowiadasz za sposób ich wykorzystania.',
        ],
      },
      {
        h: '7. Plan Free i podglądy',
        p: [
          'Podglądy są bezpłatne i zawsze zawierają znak wodny. Plan Free jest udostępniany w stanie „takim, jaki jest”, a jego limity mogą się zmieniać.',
        ],
      },
      {
        h: '8. Dostępność',
        p: [
          'Dążymy do wysokiej dostępności, ale nie gwarantujemy, że Serwis będzie działał bez przerw i błędów. Przechowuj kopie ważnych danych; szablony możesz wyeksportować w dowolnym momencie.',
        ],
      },
      {
        h: '9. Ograniczenie odpowiedzialności',
        p: [
          'Serwis jest udostępniany w stanie „takim, jaki jest”. W zakresie dopuszczalnym przez prawo nie ponosimy odpowiedzialności za szkody pośrednie, utracone korzyści ani utratę danych, a nasza łączna odpowiedzialność jest ograniczona do kwoty, którą zapłaciłeś nam w ciągu 12 miesięcy poprzedzających zgłoszenie roszczenia.',
        ],
      },
      {
        h: '10. Rozwiązanie umowy',
        p: [
          'Możesz w dowolnym momencie usunąć swoje przestrzenie robocze i zaprzestać korzystania z Serwisu. Możemy zawiesić lub zakończyć dostęp w przypadku naruszenia niniejszego regulaminu lub braku płatności; w miarę możliwości uprzedzimy Cię o tym z wyprzedzeniem i umożliwimy eksport Twoich danych.',
        ],
      },
      {
        h: '11. Zmiany i kontakt',
        p: [
          `Możemy aktualizować niniejszy regulamin; o istotnych zmianach powiadomimy Cię z wyprzedzeniem. Dalsze korzystanie z Serwisu po wejściu zmian w życie oznacza ich akceptację. Pytania: ${E}.`,
        ],
      },
    ],
  },
};
